import React from "react";
import { useParams } from "react-router-dom";
import { Container, Card, Button } from "react-bootstrap";
import led from "../images/bulb.webp";

const seriesData = {
    consumer: [
        { name: "A2B Series", range: "3W to 9W", image: led, specs: "spec1.pdf" },
        { name: "B3C Series", range: "5W to 12W", image: led, specs: "spec2.pdf" },
    ],
    professional: [
        { name: "X1 Series", range: "10W to 20W", image: led, specs: "spec3.pdf" },
    ],
    smart: [
        { name: "Smart LED", range: "7W to 15W", image: led, specs: "spec4.pdf" },
    ],
    pcb: [
        { name: "PCB Light", range: "3W to 18W", image: led, specs: "spec5.pdf" },
    ],
};

const SeriesDetail = () => {
    const { category, index } = useParams();
    const series = seriesData[category][index];

    return (
        <Container className="series-detail">
            <Card className="spec-sheet">
                <Card.Img variant="top" src={series.image} className="product-image" />
                <Card.Body>
                    <Card.Title className="title">{series.name}</Card.Title>
                    <Card.Text className="text">{series.range}</Card.Text>
                    <Button variant="primary" onClick={() => window.open(series.specs)} className="view-spec">
                        View Spec Sheet
                    </Button>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default SeriesDetail;
